module.exports = __webpack_public_path__ + "static/media/belgazprombank.3aa07cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belgazprombank.png
// module id = 321
// module chunks = 0